import React from 'react';
import { Mail, MapPin, FileText } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function FourthSection() {
  const navigate = useNavigate();
  
  // Simulasi data posisi yang tersedia
  const availableJobs = []; // Kosongkan array untuk simulasi tidak ada posisi
  
  const handleEmailClick = () => {
    window.open('https://mail.google.com/mail/?view=cm&fs=1&to=papakilobarbershop@gmail.com', '_blank');
  };

  const handlePositionsClick = () => {
    if (availableJobs.length === 0) {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
        
      });

      Toast.fire({
        icon: 'warning',
        title: 'Belum ada posisi tersedia',
        text: 'Silakan cek kembali nanti'
      });
    } else {
      navigate('/jobs');
    }
  };

  return (
    <div className="min-h-screen">
      <div className="bg-white p-8 shadow-lg rounded-2xl">
        <div className="max-w-3xl mx-auto space-y-10">
          {/* Email Section */}
          <div 
            className="flex items-center space-x-4 hover:bg-gray-50 p-4 rounded-xl transition-colors cursor-pointer"
            onClick={handleEmailClick}
          >
            <div className="bg-purple-100 p-3 rounded-full">
              <Mail className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-1">Email</h2>
              <p className="text-gray-500 hover:text-purple-600 transition-colors">
                papakilobarbershop@gmail.com
              </p>
            </div>
          </div>

          {/* Head Office Section */}
          <div className="flex items-start space-x-4 p-4">
            <div className="bg-purple-100 p-3 rounded-full flex-shrink-0">
              <MapPin className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-2">Head Office</h2>
              <p className="text-gray-500 leading-relaxed">
                The City Resort Residence Rukan Malibu Blok. I No.18-19,
                <br />Tower GRHA 911,
                <br />Jl. Boulevard Raya, RT.7/RW.14,
                <br />Cengkareng Timur, Kecamatan Cengkareng,
                <br />Kota Jakarta Barat, DKI Jakarta 11730
              </p>
            </div>
          </div>

          {/* Store Locations Section */}
          <div 
            className="flex items-center space-x-4 hover:bg-gray-50 p-4 rounded-xl transition-colors">
            <div className="bg-purple-100 p-3 rounded-full">
              <MapPin className="w-8 h-8 text-purple-600" />
            </div>
            <div>
              <h2 className="text-gray-800 text-xl font-bold uppercase mb-1">
                Lokasi Pusat Pelatihan
              </h2>
              <p className="text-gray-500">Temukan lokasi terdekat</p>
            </div>
          </div>

          {/* Google Map Office Location */}
          <div className="rounded-xl overflow-hidden border border-gray-200 relative">
            <iframe
              loading="lazy"
              className="w-full h-96"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d247.9348582688508!2d106.73366073779533!3d-6.136381514699829!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e6a02b37078a07f%3A0x21a4a3ad4e665e4e!2sPT.%20Barakuda%20Sistema%20Indonesia!5e0!3m2!1sid!2sid!4v1739426494333!5m2!1sid!2sid"
              title="Papakilo Hairstudio Location"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <a 
                href="https://www.google.com/maps/dir/?api=1&destination=-6.136381514699829 ,106.73366073779533"
                target="_blank"
                rel="noopener noreferrer"
                className="absolute bottom-4 right-4 bg-purple-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-purple-700 transition-colors"
              >
                Lihat di Google Maps
              </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FourthSection;